import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { events as eventsApi } from "../lib/api";
import { to12hr } from "../lib/format";
import { useReservationModal } from "../contexts/ReservationModalContext";

export default function ReservationsPage() {
  const [params] = useSearchParams();
  const [events, setEvents] = useState([]);
  const { open: openReservation } = useReservationModal();

  useEffect(() => {
    eventsApi.list("upcoming").then(setEvents).catch(() => {});
  }, []);

  // Auto-open only when URL has ?event=… (deep link from event detail)
  useEffect(() => {
    const evParam = params.get("event");
    if (!evParam) return;
    const t = setTimeout(() => openReservation({ eventId: evParam }), 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main data-testid="reservations-page" className="pt-28 min-h-screen bg-white pb-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 pt-12 mb-12">
        <span className="eyebrow">— Reservations</span>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-4 leading-tight text-ink">Reserve a Table at DC's #1 <span className="text-gold">Rooftop Lounge</span></h1>
        <p className="text-muted max-w-xl mt-4">Pick your event, choose your table from our interactive floor plan, and our team confirms within 24 hours.</p>
      </div>

      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-baseline justify-between mb-6">
          <p className="eyebrow">— Upcoming Nights</p>
          <button data-testid="reserve-open-modal" onClick={() => openReservation()} className="text-[11px] tracking-luxe uppercase text-gold hover:text-ink transition">
            Open Reservation Wizard →
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((e) => (
            <button
              key={e.id}
              data-testid={`reserve-event-${e.id}`}
              onClick={() => openReservation({ eventId: e.id })}
              className="group text-left border border-black/10 hover:border-ink bg-white transition flex"
            >
              <div className="w-32 flex-shrink-0 bg-black aspect-[3/4] overflow-hidden">
                {e.flyer_url ? (
                  <img src={e.flyer_url} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : null}
              </div>
              <div className="flex-1 p-5 flex flex-col">
                <p className="text-[10px] tracking-luxe uppercase text-gold">
                  {new Date(e.date + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
                </p>
                <h3 className="font-display text-xl text-ink leading-tight mt-1 line-clamp-2">{e.title}</h3>
                <p className="text-[12px] text-muted mt-1">{to12hr(e.start_time)} – {to12hr(e.end_time)}</p>
                <span className="mt-auto pt-3 text-[10px] tracking-luxe uppercase text-ink group-hover:text-gold transition">Reserve →</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </main>
  );
}
